<!--菜单栏-->
<template>
  <section class="container">
    <div
      v-if="showSidebar"
      class="aisde-page">
      <div class="header">
        <div class="hidden-sm-and-down-slide">
          <div class="header-logo">
            <div class="logo-container">
              <img
                src="@/assets/tenlife-logo.png"
                alt="logo" />

              <span class="name">{{cs_name}}</span>
            </div>
            <div class="icons">
              <font-awesome-icon
                icon="minimize"
                class="pointer icon"
                @click="handlerHide"/>

              <font-awesome-icon
                icon="right-from-bracket"
                class="pointer icon"
                @click="handlerLogout"/>
            </div>
          </div>
        </div>
      </div>
      <el-aside class="aside-container-el">
        <el-menu
          :default-openeds="openeds"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          @select="handleSelect">
          <el-submenu
            v-for="(item, index) in menuList"
            :key="index"
            :class="{'height0': item.title === ''}"
            :index="'open'+index">
            <template slot="title">{{ item.title }}</template>
            <el-menu-item
              v-for="(inItem, inIndex) in item.children"
              v-if="!inItem.removed"
              :key="inIndex"
              :index="index+'-'+inIndex"
              @click="routerTo(inItem.path)">
              <router-link
                class="in-title flex flex-sb"
                :class="{'to-be-removed': inItem.removed}"
                :to="inItem.path">
                <span
                  v-if="selectIndex === index+'-'+inIndex"
                  class="flag"></span>
                <span class="flex-center">
                  <font-awesome-icon
                    v-if="inItem.icon"
                    class="icon"
                    :class="{'to-be-removed': inItem.removed}"
                    :icon="inItem.icon"/>
                  {{ inItem.title }}
                </span>
                <!--<span  v-if="inItem.isDot">
                  <el-badge
                    :value="inItem.num"
                    :max="99"
                    class="aside-dot"
                    :class="{'is-update':inItem.updated,'is-info':inItem.isInfo}">
                  </el-badge>
                </span>-->
              </router-link>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
    </div>
    <div
      v-else
      class="hide">
      <span
        class="circle pointer"
        @click="handlerHide">
        <font-awesome-icon
          icon="maximize"
          class="icon"/>
      </span>
    </div>
  </section>
</template>
<script>
import {mapActions} from 'vuex'
import {getListCount, logout} from '@api/index'

export default {
  name: 'VAside',
  data() {
    return {
      //展开菜单栏
      openeds: ['open0', 'open1', 'open2', 'open3', 'open4', 'open5', 'open6'],
      countList:{},
      showSidebar: true,
      selectIndex: ''
    }
  },
  computed:{
    cs_name(){
      let name = localStorage.getItem('cs_name')||'Admin'
      return name
    },
    menuList(){
      let {referrer_pending_verify_num,sme_ticket_pending_num,customer_pending_verify_num,incomplete_num,insurer_num,unresolved_have_client_updated, ticket_have_client_updated,ticket_count_num,policy_have_client_updated, policy_count_num,unresolved_count_num,pv_renew_pending_num,enquiry_count_num,enquiry_have_client_updated} = this.countList||{}
      let data = [
        {
          title: '',
          open: true,
          children: [
            {
              title: 'CS Home',
              path: '/cs-home',
              icon: 'home',
            },
            {
              title: 'Enquiry',
              title: 'Enquiry',
              path: '/enquiry/list',
              icon: 'comment-alt',
              isDot:enquiry_count_num>0?true:false,
              num: enquiry_count_num,
              updated:enquiry_have_client_updated
            },
          ]
        },
        {
          title: 'SUPPORT TICKETS',
          open: true,
          children: [
            {
              title: 'My Unresolved Tickets',
              path: '/tickets/list/unresolved',
              icon: 'user-tag',
              isDot:true,
              num: unresolved_count_num,
              updated:unresolved_have_client_updated
            },
            {
              title: 'Snoozed ',
              path: '/tickets/list/snoozed',
              icon: 'stopwatch',
              removed: true
            },
            {
              title: 'Unassigned',
              path: '/tickets/list/unassigned',
              icon: 'user-times',
              removed: true
            },
            {
              title: 'All',
              path: '/tickets/list/all',
              icon: 'ticket-alt',
              isDot:true,
              num:ticket_count_num,
              updated:ticket_have_client_updated
            }
          ]
        },
        {
          title: 'RECORDS',
          open: true,
          children: [
            {
              title: 'Policies',
              path: '/records/policy',
              icon: 'file-powerpoint',
              isDot:true,
              num:`I: ${incomplete_num} / R: ${insurer_num}`,
              updated:0,
              isInfo:true
            },
            {
              title: 'Claim',
              path: '/records/claim',
              icon: 'hand-holding-dollar',
            },
            {
              title: 'Extra Benefits',
              path: '/records/extra-benefits/list',
              icon: 'cubes',
              removed: true
            },
            {
              title: 'Micropolicy',
              path: '/records/micropolicy',
              icon: 'cubes',
              removed: true
            },
            {
              title: 'Quotes',
              path: '/records/quote',
              icon: 'money-check-alt'
            },
            {
              title: 'Rewards Activity',
              path: '/records/referral',
              icon: 'dollar'
            },
            {
              title: 'Renewal',
              path: '/records/renewal',
              icon: 'sync'
            },
            {
              title: 'Business Tickets',
              path: '/records/sme/ticket/list',
              icon: 'store',
              isDot:sme_ticket_pending_num>0?true:false,
              num: sme_ticket_pending_num,
              updated:true
            },
            {
              title: 'Campaigns ',
              path: '/records/campaigns',
              icon: 'campground',
              isDot:true,
              num: pv_renew_pending_num,
              updated:true,
              removed: true
            },
            {
              title: 'Referrer Reward',
              path: '/records/referrer',
              icon: 'gift'
            },
          ]
        },
        {
          title: '',
          open: true,
          children: [
            {
              title: 'Create Quote',
              path: '/quoting/select/create',
              icon: 'plus',
            },
          ]
        },
        {
          title: 'ACCOUNTS',
          open: true,
          children: [
            {
              title: 'Customers',
              path: '/accounts',
              icon: 'user-circle',
              num:customer_pending_verify_num,
              updated:0,
              isDot:true,
            },
            {
              title: 'Fina Referrers',
              path: '/referrer',
              icon: 'user-tie',
              num:referrer_pending_verify_num,
              updated:0,
              isDot:true,
              removed: true
            },
            {
              title: 'Insurers',
              path: '/accounts/insurer',
              icon: 'building'
            }
          ]
        },
        // {
        //   title: 'EXTERNAL PROCESSING',
        //   open: false,
        //   children: [
        //     {
        //       title: 'Bank Transfer Queue',
        //       path: '/external/bank',
        //       icon: 'piggy-bank',
        //       removed: true
        //     },
        //     {
        //       title: 'Cheque Queue',
        //       path: '/external/cheque',
        //       icon: 'money-check',
        //       removed: true
        //     }
        //   ]
        // },
        {
          title: '',
          open: true,
          children: [
            {
              title: 'Admin & CMS',
              path: '/admin-cms/promotions',
              icon: 'cog'
            }
          ]
        }
      ]
      return data
    }
  },
  created() {
    this.network().getListCount()
  },
  methods: {
    ...mapActions('coupon', ['setActiveTab']),
    ...mapActions('filter', ['setOpenFilterCar']),

    routerTo(path) {
      if (this.$route.path === path) return
      this.setActiveTab(null)
      this.$router.push(path)
    },
    handlerLogout() {
      // debugger
      this.network().logout()
    },
    handlerHide(){
      this.showSidebar = !this.showSidebar
    },
    handlerHref(){
      this.$router.push('/tickets/list/unresolved')
    },
    handleSelect(index, indexPath){
      this.selectIndex = index
    },
    network() {
      return {
        logout: async () => {
          try {
            await logout()
          } catch(e) {
            console.log(e)
          }
          localStorage.removeItem('token')
          localStorage.removeItem('refresh_token')
          localStorage.removeItem('auth')
          this.setOpenFilterCar(null)
          this.$router.replace('/login')
        },
        getListCount: async () => {
          let {data} = await getListCount()
          this.countList = data
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  overflow: auto;
  border-right: 1px solid #D1D5DA;
}
.aisde-page{
  min-height: 100%;
  background: #545c64;
  .header{
    background: #545c64;
  }
  .header-logo {
    padding: 20px 20px 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //width: 250px !important;
    .logo-container {
      display: flex;
      align-items: center;
      //justify-content: space-between;
      .flex-item{
        display: flex;
        align-items: center;
        text-decoration:none;
        color: #616266;
        span {
          font-weight: bold;
          font-size: 18px;
          line-height: 20px;
        }
      }
      img {
        margin-right: 15px;
        width: 26px;
      }
      .name {
        display: inline-block;
        font-size: 14px;
        font-weight: 500;
        color: #24292E;
      }
    }
    .icons{
      //color: #586069;
      .icon{
        padding: 3px;
      }
      .icon + .icon{
        margin-left: 20px;
      }
    }
  }
  .header-search{
    margin-left: 20px;
    .name {
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      color: #6B7280;
    }
  }
  .aside-container-el {
    height: 100%;
    overflow: hidden;
    //background: #F6F8FA;
    box-shadow: inset -1px 0 0 0 #dddfe7;
    ::v-deep .el-menu {
      //background-color: #545c64 !important;
      border-right: none;
    }

    ::v-deep .el-submenu__title {
      color: #6A737D;
      font-size: 14px;
      font-weight: 600;
      height: 44px;
      line-height: 44px;
      //margin: 14px 0 5px 0;
      i {
        color:#fff
      }
      &:hover{
        background: none;
      }
    }
    .height0{
      /deep/i {
        display: none;
      }
      /deep/.el-submenu__title{
        height: 0;
      }
    }

    ::v-deep .el-menu-item {
      height: 44px;
      line-height: 44px;
      font-weight: 500;
      //color: #fff;
      font-size: 13px;
      white-space: nowrap;
      padding: 11px 8px 11px 20px!important;
      display: flex;
      align-items: center;
      position: relative;
      border-radius: 6px;
      * {
        vertical-align: inherit !important;
      }
      &.is-active{
        background: #FFFFFF;
        color: #0366D6;
        .in-title{
          color: #fff;
          .aside-dot{
            color: #0366D6 !important;
          }
        }
        .icon{
          color: #fff !important;
        }
      }
      &:hover{
        background: none;
        color: #ffd04b;
        .icon{
          color: #ffd04b;
        }
      }
      &.is-active:hover{
        background: #FFFFFF;
      }
    }
    .in-title{
      font-weight: 500;
      color: #fff;
      font-size: 16px;
      text-decoration:none;
      width: 100%;
      display: flex;
      align-items: center;
      .flag{
        display: inline-block;
        width: 4px;
        height: 24px;
        background: #ffd04b;
        border-radius: 4px;
        position: absolute;
        left: 0;
      }
      .flex-center{
        display: flex;
        align-items: center;
        .icon{
          color: #fff;
          font-weight: 900;
          width: 16px;
          height: 16px;
          font-size: 16px;
          margin-right: 16px;
        }
      }
      &:hover{
        color: #ffd04b;
        .icon{
          color: #ffd04b;
        }
      }
      &.router-link-active{
        color: #ffd04b!important;
        .icon{
          color: #ffd04b!important;
        }
      }
    }
    .to-be-removed{
      color: #F56C6C !important;
      text-decoration: line-through;
    }
    .aside-dot{
      //height: 20px;
      //width: 20px;
      //font-size: 12px;
      //letter-spacing: 0;
      //line-height: 16px;
      //text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
       ::v-deep .el-badge__content{
        color: #24292E;
        border:1px solid #E1E4E8;
        background: #FFFFFF;
      }
      &.is-update{
        ::v-deep .el-badge__content{
          color: #fff;
          border:0;
          background-color: #0366D6;
        }
      }
      &.is-info{
        ::v-deep .el-badge__content{
          color: #24292E;
          border:0;
          background: rgba(209, 213, 218, 0.5);
        }
      }
    }
  }
}
.hide{
  .circle{
    margin: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 100px;
    background: #0366D6;
    color: #FFFFFF;
    font-weight: 900;
    font-size: 16px;
  }
}
</style>
